var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"in_price"},domProps:{"value":_vm.data.price},on:{"keyup":_vm.onInputChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }